import * as React from "react";
import * as _ from "lodash";
import {ISymptom} from "@curefit/care-common";
import {default as CustomHeader, ICustomHeaderInfo} from "../../utils/CustomHeader";
import AppUtils from "../../../utils/AppUtils";

export interface PatientSymptomViewProps {
    symptoms: ISymptom[];
}

let PhysioComplaintsEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "concern", display: "CONCERN"},
    {label: "since", display: "SINCE"},
    {label: "reason", display: "REASON"}
];

class PatientSymptomView extends React.Component<PatientSymptomViewProps> {

    constructor(props: PatientSymptomViewProps) {
        super(props);
    }

    render() {
        return (
            <div className="patient-symptom-view">
                {
                    !_.isEmpty(this.props.symptoms) &&
                    <div>
                        <CustomHeader headerInfos={PhysioComplaintsEditorHeaderInfos} rootCls={"patient-symptom"}/>
                        {
                            _.map(this.props.symptoms, function(symptom: ISymptom, index: number){
                                return (
                                    <div className="symptom-row" key={index}>
                                        <div className="smart-column patient-symptom-concern">{symptom.displayValue}</div>
                                        <div className={"smart-column patient-symptom-since"}>{AppUtils.getAlbusFrequencyText(symptom.duration, false)}</div>
                                        <div className={"smart-column"}>{symptom.comment}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
                {
                    _.isEmpty(this.props.symptoms) &&
                    <div>No complaints to show</div>
                }
            </div>
        );
    }
}

export default PatientSymptomView